module.exports = __webpack_public_path__ + "img/OMSK.5e68d474.png";